export default __webpack_public_path__ + "static/media/land-3.8c9c09fa.png";